/**
 * Button can be rendered in these sizes
 */
export var ButtonSize;

(function (ButtonSize) {
  ButtonSize["Normal"] = "NORMAL";
  ButtonSize["Tiny"] = "TINY";
})(ButtonSize || (ButtonSize = {}));